export default "__VITE_ASSET__92fb93d8__"